/**
 * TASK-917 — Visit Site href: usable shop website, else Google Maps place page.
 */

const JUNK_HOST_HINTS = [
  'zillow.com',
  'realtor.com',
  'redfin.com',
  'trulia.com',
  'facebook.com/login',
];

export function isUsableShopWebsiteUrl(url) {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  let parsed;
  try {
    parsed = new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
  const hostPath = `${parsed.hostname}${parsed.pathname}`.toLowerCase();
  if (JUNK_HOST_HINTS.some((h) => hostPath.includes(h))) return false;
  return true;
}

export function googleMapsPlaceHref(placeId) {
  if (!placeId || typeof placeId !== 'string' || !placeId.trim()) return null;
  const id = encodeURIComponent(placeId.trim());
  return `https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${id}`;
}

/**
 * @param {{ url?: string|null, place_id?: string|null, name?: string, shop_name?: string, address?: string }} shop
 */
export function resolveVisitSiteHref(shop) {
  const url = shop?.url;
  if (isUsableShopWebsiteUrl(url)) {
    return url.includes('://') ? url.trim() : `https://${url.trim()}`;
  }
  const maps = googleMapsPlaceHref(shop?.place_id);
  if (maps) return maps;

  const name = shop?.shop_name || shop?.name || '';
  const address = shop?.address || '';
  const q = `${name} ${address}`.trim();
  if (q) {
    return `https://www.google.com/search?q=${encodeURIComponent(q)}`;
  }
  return null;
}
